import React, { useEffect, useState } from 'react';
import TextInfo from '@gcloud-npm/next12.components.text-info-n';
import Image from '@gcloud-npm/next12.components.image-n';
import useMediaQuery from '@/hooks/useMediaQuery';

const SectionImageText = (props) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const isDesktop = useMediaQuery('(min-width: 1224px)');
  return (
    <>
      <section className="SectionImageText">
        <div className="container">
          {isMobile ? (
            <Image
              src={`${process.env.NEXT_PUBLIC_CDN}/${props['Image-1'].picMobile.src}`}
              alt={props['Image-1'].alt}
              layout="responsive"
              width={props['Image-1'].picMobile.width}
              height={props['Image-1'].picMobile.height}
            />
          ) : (
            <Image
              src={`${process.env.NEXT_PUBLIC_CDN}/${props['Image-1'].picDesktop.src}`}
              alt={props['Image-1'].alt}
              layout="responsive"
              width={props['Image-1'].picDesktop.width}
              height={props['Image-1'].picDesktop.height}
            />
          )}
          <TextInfo {...props['TextInfo-1']} />
        </div>
      </section>
      <style jsx>
        {`
          .SectionImageText {
            background-color: var(--color-emp--grey1);
            padding: 1.25rem;
          }
        `}
      </style>
    </>
  );
};

export default SectionImageText;
